module.exports = __webpack_public_path__ + "static/img/文案策划-slogan.0267fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10008/文案策划-slogan.png
// module id = fPGi
// module chunks = 1